import { generateController, generateDTO, generateModule, generateService } from './generator';
import { DrizzleSchemaParser } from './schema-parser';
import { join } from 'path';
import { toSnakeCase } from './utils';
import { mkdir, rm, writeFile } from 'fs/promises';
import { existsSync } from 'fs';

export interface Options {
  tsConfigFilePath: string;
  schemaFilePath: string;
  moduleOutputDir: string;
}

export async function parseAndGenerateNestResourceTemplate(options: Options) {
  const parser = new DrizzleSchemaParser({
    tsConfigFilePath: options.tsConfigFilePath,
  });
  const tables = parser.parseSchemaFile(options.schemaFilePath);

  if (tables.length === 0) {
    console.warn('未解析到任何数据库表，无需生成 Nest.js 模块模板');
    return;
  }

  // 按照变量名长度排序，降序
  tables.sort((a, b) => b.variableName.length - a.variableName.length);

  const table = tables[0];

  // 生成代码，只生成一个模块的
  console.info(`生成 Nest.js ${table.variableName} 模块`);
  const filePath = toSnakeCase(table.variableName);
  const moduleDir = join(options.moduleOutputDir, filePath);
  if (existsSync(moduleDir)) {
    console.info(`Nest.js 模块 ${filePath} 已存在，跳过生成代码`);
    return;
  }
  const dto = generateDTO(table);
  const controller = generateController(table);
  const service = generateService(table);
  const moduleFilePath = join(moduleDir, `${filePath}.module.ts`);
  const module = generateModule(table);

  try {
    await mkdir(moduleDir, { recursive: true });
    await mkdir(join(moduleDir, 'dtos'), { recursive: true });
    await writeFile(join(moduleDir, 'dtos', `${filePath}.dto.ts`), dto);
    await writeFile(join(moduleDir, `${filePath}.controller.ts`), controller);
    await writeFile(join(moduleDir, `${filePath}.service.ts`), service);
    await writeFile(moduleFilePath, module);
  } catch (err) {
    console.error(`生成 Nest.js ${filePath} 模块失败: ${(err as Error).message}`);
    await rm(moduleDir, { recursive: true });
  }
}

// const projectDir = '/Users/bytedance/Workspace/nestjs-react-fullstack-template';
// const tsConfigFilePath = join(projectDir, './tsconfig.json');
// const schemaFilePath = join(projectDir, './server/database/schema.ts');

// const tmp = mkdtempSync(join(tmpdir(), 'tmp-'));
// console.log('生成到 ', tmp);

// parseAndGenerateNestResourceTemplate({
//   tsConfigFilePath,
//   schemaFilePath,
//   moduleOutputDir: tmp,
// }).finally(() => {
//   console.log('NestJS 资源模板生成完成');
// });
